const notification = document.getElementById('notification');

const closeNotification = () => {
  if (notification) {
    const parent = notification.parentElement;

    if (parent) {
      parent.removeChild(notification);
      sessionStorage.hideNotification = true;
    }
  }
};

if (notification) {
  if (sessionStorage.hideNotification) {
    closeNotification();
  }

  const buttons = Array.from(notification.querySelectorAll('button'));

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      closeNotification();
    });
  });
}
